export default __webpack_public_path__ + "static/media/revenue.1491598d.svg";